module.exports = __webpack_public_path__ + "img/mouse_border_icon.8fc29713.png";